export default [
  {
    path: '/gk-recommender/index',
    name: 'Index',
    component: () => import('@/views/gk-recommender/index'),
    meta: {
      title: '高考直通车-车车推荐官'
    }
  },
  
]
